import { create } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';

import { Chart, Document, Metric, Query } from 'types/api';

export type AddDocModalType = undefined | 'manual' | 'csv' | 'pdf' | 'url' | 'custom';

type State = {
  // Modal states
  queryToUnsave?: Query;
  chartsToDelete: Chart[];
  documentToDelete?: Document;
  metricToDelete?: Metric;

  showConnectDataModal: boolean;
  showAddDocModal: AddDocModalType;

  newChatInput: string;
};

type Actions = {
  // AppActions
  resetGraph: () => void;
  setNewChatInput: (newChatInput: string) => void;

  // Modal actions
  setQueryToUnsave: (queryToUnsave?: Query) => void;
  setChartsToDelete: (charts: Chart[]) => void;
  setDocumentToDelete: (documentToDelete?: Document) => void;
  setMetricToDelete: (metricToDelete?: Metric) => void;

  setShowAddDocModal: (showAddDocModal: AddDocModalType) => void;
  toggleConnectDataModal: () => void;
};

export type AppState = State & Actions;

const initialState: State = {
  queryToUnsave: undefined,
  chartsToDelete: [],
  documentToDelete: undefined,
  metricToDelete: undefined,
  showConnectDataModal: false,
  showAddDocModal: undefined,
  newChatInput: '',
};

const useStore = create<AppState>()(
  devtools(
    subscribeWithSelector((set, get) => ({
      ...initialState,
      resetGraph: () => {
        set(initialState);
      },
      setNewChatInput: (newChatInput) => {
        set({ newChatInput });
      },
      setQueryToUnsave: (queryToUnsave) => {
        set({ queryToUnsave });
      },
      setChartsToDelete: (chartsToDelete) => {
        set({ chartsToDelete });
      },
      setDocumentToDelete: (documentToDelete) => {
        set({ documentToDelete });
      },
      setMetricToDelete: (metricToDelete) => {
        set({ metricToDelete });
      },
      setShowAddDocModal: (newValue) => {
        set({ showAddDocModal: newValue });
      },
      toggleConnectDataModal: () => {
        set({ showConnectDataModal: !get().showConnectDataModal });
      },
    })),
    { enabled: process.env.NODE_ENV === 'development' },
  ),
);

export default useStore;
